var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fac-pill-container"},[_c('div',{staticClass:"pill",class:_vm.safariClass,attrs:{"tabindex":"0","role":"definition"}},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }